<template>
  <g>
    <path
      d="M15.5416 8.83363C15.0357 8.83363 14.6218 8.41975 14.6218 7.91389C14.6218 6.49749 15.7807 5.33862 17.1971 5.33862H23.3134C23.8192 5.33862 24.2331 5.7525 24.2331 6.25836C24.2331 6.76422 23.8192 7.1781 23.3134 7.1781H17.1971C16.7924 7.1781 16.4613 7.50921 16.4613 7.91389C16.4613 8.41975 16.0566 8.83363 15.5416 8.83363Z"
      :fill="iconColor"
    />
    <path
      d="M15.5418 25.8102C15.036 25.8102 14.6221 25.3963 14.6221 24.8905C14.6221 23.4741 15.7809 22.3152 17.1973 22.3152H23.3136C23.8195 22.3152 24.2333 22.7291 24.2333 23.2349C24.2333 23.7408 23.8195 24.1547 23.3136 24.1547H17.1973C16.7927 24.1547 16.4615 24.4858 16.4615 24.8905C16.4615 25.3963 16.0569 25.8102 15.5418 25.8102Z"
      :fill="iconColor"
    />
    <path
      d="M15.5607 8.83485C15.0548 8.83485 14.6409 8.42097 14.6409 7.91511C14.6409 7.51043 14.3098 7.17932 13.9051 7.17932H7.78888C7.28302 7.17932 6.86914 6.76544 6.86914 6.25958C6.86914 5.75373 7.28302 5.33984 7.78888 5.33984H13.9051C15.3215 5.33984 16.4804 6.49872 16.4804 7.91511C16.4804 8.42097 16.0665 8.83485 15.5607 8.83485Z"
      :fill="iconColor"
    />
    <path
      d="M15.5589 25.8114C15.0531 25.8114 14.6392 25.3975 14.6392 24.8917C14.6392 24.487 14.3081 24.1559 13.9034 24.1559H7.78717C7.28131 24.1559 6.86743 23.742 6.86743 23.2361C6.86743 22.7303 7.28131 22.3164 7.78717 22.3164H13.9034C15.3198 22.3164 16.4787 23.4753 16.4787 24.8917C16.4787 25.3975 16.0648 25.8114 15.5589 25.8114Z"
      :fill="iconColor"
    />
    <path
      d="M7.69562 24.1516C7.18976 24.1516 6.77588 23.7378 6.77588 23.2319V6.29034C6.77588 5.78449 7.18976 5.37061 7.69562 5.37061C8.20147 5.37061 8.61535 5.78449 8.61535 6.29034V23.2319C8.61535 23.7378 8.21067 24.1516 7.69562 24.1516Z"
      :fill="iconColor"
    />
    <path
      d="M23.3126 24.1504C22.8067 24.1504 22.3928 23.7365 22.3928 23.2307V6.28912C22.3928 5.78327 22.8067 5.36938 23.3126 5.36938C23.8184 5.36938 24.2323 5.78327 24.2323 6.28912V23.2307C24.2323 23.7365 23.8276 24.1504 23.3126 24.1504Z"
      :fill="iconColor"
    />
    <path
      d="M15.5416 25.4978C15.0357 25.4978 14.6218 25.0839 14.6218 24.5781V7.63653C14.6218 7.13068 15.0357 6.7168 15.5416 6.7168C16.0474 6.7168 16.4613 7.13068 16.4613 7.63653V24.5781C16.4613 25.0839 16.0566 25.4978 15.5416 25.4978Z"
      :fill="iconColor"
    />
    <path
      d="M25.6027 26.6604H7.98053C7.47467 26.6604 7.06079 26.2466 7.06079 25.7407C7.06079 25.2348 7.47467 24.821 7.98053 24.821H24.9037V7.1712C24.9037 6.66535 25.3176 6.25146 25.8234 6.25146C26.3293 6.25146 26.7432 6.66535 26.7432 7.1712V25.52C26.7432 26.1546 26.2373 26.6604 25.6027 26.6604Z"
      :fill="iconColor"
    />
    <path
      d="M23.0285 26.6604H5.40635C4.78093 26.6604 4.26587 26.1546 4.26587 25.52V7.1712C4.26587 6.66535 4.67975 6.25146 5.18561 6.25146C5.69146 6.25146 6.10534 6.66535 6.10534 7.1712V24.821H23.0285C23.5344 24.821 23.9483 25.2348 23.9483 25.7407C23.9483 26.2558 23.5436 26.6604 23.0285 26.6604Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
